module.exports = __webpack_public_path__ + "static/media/phone_ko.ad569a49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/intro-2/phone_ko.jpg
// module id = 693
// module chunks = 0